var map = {
	"./arrow-down-sign-to-navigate.svg": 635,
	"./background.png": 306,
	"./banner.png": 144,
	"./codepen.png": 351,
	"./cv.svg": 675,
	"./mini_projet.jpg": 568,
	"./odsscreen.jpg": 596,
	"./paolo_trapu.jpg": 621,
	"./shape.svg": 13,
	"./webagency.png": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;